module.exports = __webpack_public_path__ + "img/fm-f-Path 51 Copy@3x.60861a66.png";